'use client';

export function AnnouncementBar() {
  return (
    <div className="py-2 px-4 text-center text-xs font-medium bg-slate-900 dark:bg-card text-slate-200 dark:text-foreground/90 flex items-center justify-center flex-wrap gap-x-3 gap-y-1 border-b border-slate-800 dark:border-border/80 transition-colors duration-200">
      <span className="flex items-center gap-1.5">
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 dark:bg-emerald-500 animate-pulse" />
        Atendimento por vídeo em todo o Brasil
      </span>
      <span className="text-slate-500 dark:text-border hidden sm:inline" aria-hidden="true">•</span>
      <span>Profissionais verificados pelo CFM</span>
      <span className="text-slate-500 dark:text-border hidden sm:inline" aria-hidden="true">•</span>
      <span>Pagamento 100% protegido</span>
    </div>
  );
}
